import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const burnAsset = (data) => request.post(`${API_BASE_URL}/blockchain/burn`, data)

export default burnAsset